// 剧目销售看板 - 接口请求封装（web 入口）
import request from '@/utils/request';

// 0. 剧目搜索
export function queryShowList(param) {
  return request('/show-dashboard/queryShowList', {
    method: 'POST',
    data: param,
  });
}

// 1. 销售总览
export function queryShowOverview(param) {
  return request('/show-dashboard/queryShowOverview', {
    method: 'POST',
    data: param,
  });
}

// 2. VIP
export function queryShowVip(param) {
  return request('/show-dashboard/queryShowVip', {
    method: 'POST',
    data: param,
  });
}

// 3. 访问与销售趋势（合并 PV/UV/日应付）
export function queryShowVisitSalesTrend(param) {
  return request('/show-dashboard/queryShowVisitSalesTrend', {
    method: 'POST',
    data: param,
  });
}

// 4. 购票漏斗
export function queryShowFunnel(param) {
  return request('/show-dashboard/queryShowFunnel', {
    method: 'POST',
    data: param,
  });
}

// 5. 访问地域 TOP5
export function queryShowRegionTop(param) {
  return request('/show-dashboard/queryShowRegionTop', {
    method: 'POST',
    data: param,
  });
}

// 6. 分场次销售
export function queryShowSessionStack(param) {
  return request('/show-dashboard/queryShowSessionStack', {
    method: 'POST',
    data: param,
  });
}

// 7. 售票渠道
export function queryShowChannel(param) {
  return request('/show-dashboard/queryShowChannel', {
    method: 'POST',
    data: param,
  });
}
